import { Vector3 } from 'three';
import type { Object3D } from 'three';

const shoulderAt = new Vector3();
const toTarget = new Vector3();
const bend = new Vector3();
const elbowAt = new Vector3();

/**
 * Points an arm of two segments (each along its own +Z) at a target: the upper arm from the shoulder to where the elbow
 * must be, the forearm from there to the target. The elbow bends towards `pole`. Out of reach, the arm points straight at
 * the target. All positions are in the world.
 */
export function reach(upper: Object3D, fore: Object3D, upperLength: number, foreLength: number, target: Vector3, pole: Vector3): void {
  upper.parent!.updateWorldMatrix(true, false);
  upper.getWorldPosition(shoulderAt);
  toTarget.subVectors(target, shoulderAt);
  const distance = Math.min(Math.max(toTarget.length(), Math.abs(upperLength - foreLength) + 1e-4), upperLength + foreLength - 1e-4);
  toTarget.normalize();
  // How far along the line to the target the elbow sits, and how far off it towards the pole.
  const along = (upperLength * upperLength - foreLength * foreLength + distance * distance) / (2 * distance);
  const off = Math.sqrt(Math.max(0, upperLength * upperLength - along * along));
  bend.copy(pole).addScaledVector(toTarget, -pole.dot(toTarget)).normalize();
  elbowAt.copy(shoulderAt).addScaledVector(toTarget, along).addScaledVector(bend, off);
  upper.lookAt(elbowAt);
  upper.updateWorldMatrix(false, false);
  fore.lookAt(target);
}
